/**
 * 动态加载CSS
 * @param cssPath 
 */
export const loadCSS = (cssPath: string) => {
  const styleSheets = document.styleSheets;
  const var_o = styleSheets.length;
  for (let i = 0; i < var_o; i++) {
    if (styleSheets[i] && styleSheets[i].href && styleSheets[i].href!.indexOf(cssPath) !== -1) {
      return;
    }
  }
  let link;
  link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = cssPath;
  document.getElementsByTagName("head")[0].appendChild(link);
}